import { render, staticRenderFns } from "./statistic_trans.vue?vue&type=template&id=d8438f1e"
import script from "./statistic_trans.vue?vue&type=script&lang=js"
export * from "./statistic_trans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports